import React from 'react'

import { LineChartWidget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import { padTimeSeries } from 'modules/ticketing/lib/padTimeSeries'

type ResolutionTimePoint = {
  label: string
  averageSeconds: number
}

type Props = {
  data: ResolutionTimePoint[]
  period: string
}

export const InsightsResolutionTimeChart: React.FC<Props> = ({ data, period }) => {
  const paddedData = padTimeSeries(data, period, { averageSeconds: 0 })

  const chartData = paddedData.map((point) => ({
    label: point.label,
    values: {
      avgResolutionTime: Math.round((point.averageSeconds / 3600) * 10) / 10,
    },
  }))

  return (
    <LineChartWidget
      header={{
        title: i18n.t('ticketing.inbox.insights.charts.resolution_time'),
      }}
      chart={{
        data: chartData,
        dataConfig: {
          avgResolutionTime: {
            label: i18n.t('ticketing.inbox.insights.charts.avg_resolution_time_hours'),
            color: 'categorical-2',
          },
        },
      }}
    />
  )
}
